<template>
    <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_121_45)">
            <path
                d="M48.9375 20.5195H2.0625C1.19922 20.5195 0.5 19.8203 0.5 18.957V11.7305C0.5 10.8672 1.19922 10.168 2.0625 10.168H48.9375C49.8008 10.168 50.5 10.8672 50.5 11.7305V18.957C50.5 19.8203 49.8008 20.5195 48.9375 20.5195ZM3.625 17.3945H47.375V13.293H3.625V17.3945Z"
                fill="currentColor" />
            <path
                d="M46.0078 48.6445H4.99219C4.12891 48.6445 3.42969 47.9453 3.42969 47.082V18.957C3.42969 18.0938 4.12891 17.3945 4.99219 17.3945H46.0078C46.8711 17.3945 47.5703 18.0938 47.5703 18.957V47.082C47.5703 47.9453 46.8711 48.6445 46.0078 48.6445ZM6.55469 45.5195H44.4453V20.5195H6.55469V45.5195Z"
                fill="currentColor" />
            <path
                d="M12.5117 30.2852C11.6484 30.2852 10.9492 29.5859 10.9492 28.7227V24.2305C10.9492 23.3672 11.6484 22.668 12.5117 22.668C13.375 22.668 14.0742 23.3672 14.0742 24.2305V28.7227C14.0742 29.5859 13.375 30.2852 12.5117 30.2852Z"
                fill="currentColor" />
            <path
                d="M14.7578 28.0391H10.2656C9.40234 28.0391 8.70312 27.3398 8.70312 26.4766C8.70312 25.6133 9.40234 24.9141 10.2656 24.9141H14.7578C15.6211 24.9141 16.3203 25.6133 16.3203 26.4766C16.3203 27.3398 15.6211 28.0391 14.7578 28.0391Z"
                fill="currentColor" />
            <path
                d="M40.7344 28.0391H36.2422C35.3789 28.0391 34.6797 27.3398 34.6797 26.4766C34.6797 25.6133 35.3789 24.9141 36.2422 24.9141H40.7344C41.5977 24.9141 42.2969 25.6133 42.2969 26.4766C42.2969 27.3398 41.5977 28.0391 40.7344 28.0391Z"
                fill="currentColor" />
            <path
                d="M24.5223 42.7852C23.2918 42.7852 22.5194 41.3945 23.2303 40.3457L25.6795 36.7295H22.3748C21.1239 36.7295 20.3787 35.3271 21.0809 34.291L25.1824 28.2363C25.6668 27.5215 26.6385 27.335 27.3524 27.8193C28.0672 28.3037 28.2537 29.2744 27.7694 29.9893L25.3201 33.6055H28.6248C29.8758 33.6055 30.6209 35.0078 29.9188 36.0439L25.8172 42.0986C25.5155 42.5449 25.0233 42.7852 24.5223 42.7852Z"
                fill="currentColor" />
            <path
                d="M15.6367 13.293H9.38672C8.52344 13.293 7.82422 12.5938 7.82422 11.7305V6.45703C7.82422 5.59375 8.52344 4.89453 9.38672 4.89453H15.6367C16.5 4.89453 17.1992 5.59375 17.1992 6.45703V11.7305C17.1992 12.5938 16.5 13.293 15.6367 13.293ZM10.9492 10.168H14.0742V8.01953H10.9492V10.168Z"
                fill="currentColor" />
            <path
                d="M12.5117 7.82422C11.6484 7.82422 10.9492 7.125 10.9492 6.26172V3.91797C10.9492 3.05469 11.6484 2.35547 12.5117 2.35547C13.375 2.35547 14.0742 3.05469 14.0742 3.91797V6.26172C14.0742 7.125 13.375 7.82422 12.5117 7.82422Z"
                fill="currentColor" />
            <path
                d="M41.6133 13.293H35.3633C34.5 13.293 33.8008 12.5938 33.8008 11.7305V6.45703C33.8008 5.59375 34.5 4.89453 35.3633 4.89453H41.6133C42.4766 4.89453 43.1758 5.59375 43.1758 6.45703V11.7305C43.1758 12.5938 42.4766 13.293 41.6133 13.293ZM36.9258 10.168H40.0508V8.01953H36.9258V10.168Z"
                fill="currentColor" />
            <g opacity="0.2">
                <path d="M48.9375 11.7305V18.957H37.7363C40.1514 17.4199 41.5146 14.6279 41.1709 11.7305H48.9375Z"
                    fill="currentColor" />
            </g>
            <g opacity="0.2">
                <path d="M46.0078 18.957V47.082H25.1953C35.2539 41.7314 42.1016 31.1436 42.1016 18.957H46.0078Z"
                    fill="currentColor" />
            </g>
            <g opacity="0.2">
                <path d="M41.6133 6.45703V11.7305H35.54C37.9619 11.2275 39.585 8.90918 39.2197 6.45703H41.6133Z"
                    fill="currentColor" />
            </g>
            <g opacity="0.2">
                <path d="M15.6367 6.45703V11.7305H9.56348C11.9854 11.2275 13.6084 8.90918 13.2432 6.45703H15.6367Z"
                    fill="currentColor" />
            </g>
            <path
                d="M38.4883 7.82422C37.625 7.82422 36.9258 7.125 36.9258 6.26172V3.91797C36.9258 3.05469 37.625 2.35547 38.4883 2.35547C39.3516 2.35547 40.0508 3.05469 40.0508 3.91797V6.26172C40.0508 7.125 39.3516 7.82422 38.4883 7.82422Z"
                fill="currentColor" />
        </g>
        <defs>
            <clipPath id="clip0_121_45">
                <rect width="50" height="50" fill="white" transform="translate(0.5 0.5)" />
            </clipPath>
        </defs>
    </svg>
</template>